<template>
  <v-container fluid v-if="show">
    <v-dialog data-testid="confirmation-modal" v-model="show" max-width="600px">
      <v-card>
        <v-card-title class="secondary white--text d-flex align-center justify-space-between">
          <span class="header-font" style="font-size: 22px;">{{ $t(title) }}</span>
        </v-card-title>
        <v-card-text class="mt-5">
          <v-container class="pt-0">
            <v-row>
              <v-col cols="12" class="pa-0">
                <span class="body-1 primary--text">{{ $t(message) }}</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-end pr-6 pb-4">
          <v-btn data-testid="confirmation-no" :color="$vuetify.theme.dark ? 'white' : 'secondary'" rounded outlined class="elevation-0 monospace-font px-4" v-if="showNoButton" @click="onConfirmationClick(false)">{{$t(noLabel)}}</v-btn>
          <v-btn data-testid="confirmation-yes" 
            rounded class="elevation-0 monospace-font white--text px-4" color="primary"
            ref="confirmationButton" :loading="loading"
            @click="onConfirmationClick(true)"
          >{{$t(yesLabel)}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import * as _ from "lodash";

export default {
  name: "ConfirmationModal",
  components: {},
  props: {
    title: {
      type: String,
      default: "general.confirmationTitle"
    },
    message: {
      type: String,
      default: "general.confirmationMessage"
    },
    noLabel: {
      type: String,
      default: "general.cancel"
    },
    yesLabel: {
      type: String,
      default: "general.yes"
    },
    showNoButton: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.onDialogClosed();
      }
    }
  },
  data() {
    return {
      show: false,
      wasHandled: false,
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    open(obj = {}) {
      this.show = true;
      this.obj = obj;
      this.wasHandled = false;
      this.$forceUpdate();
      setTimeout(function(ctx){ctx.$refs.confirmationButton.$el.focus()},1,this);
    },
    close() {
      this.show = false;
      this.obj = null;
    },
    async onConfirmationClick(value) {
      this.wasHandled = true;
      this.$emit("confirmation", value);
    },
    onDialogClosed() {
      //Close dialog on ESC or click outside as cancel
      if (!this.wasHandled) this.$emit("confirmation", false);
      this.wasHandled = false;
    }
  }
};
</script>
